// Small format helpers — Italian locale.
export function formatCurrency(v) {
  if (v === null || v === undefined || v === "") return "—";
  const n = typeof v === "number" ? v : Number(v);
  if (Number.isNaN(n)) return String(v);
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n);
}

export function formatDate(v) {
  if (!v) return "—";
  const d = v instanceof Date ? v : new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function formatDateTime(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString("it-IT", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Europe/Rome",
  });
}

export function formatBytes(n) {
  if (!n && n !== 0) return "—";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0; let val = n;
  while (val >= 1024 && i < units.length - 1) { val /= 1024; i++; }
  return `${val.toFixed(val < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

export function confidenceClass(c) {
  if (c === null || c === undefined) return "pxos-conf-low";
  if (c >= 0.9) return "pxos-conf-high";
  if (c >= 0.75) return "pxos-conf-med";
  return "pxos-conf-low";
}

export function confidenceLabel(c) {
  if (c === null || c === undefined) return "Sconosciuta";
  if (c >= 0.9) return "Alta";
  if (c >= 0.75) return "Media";
  return "Bassa";
}

export function statusMeta(s) {
  const map = {
    pending: { label: "In attesa", cls: "pxos-status-pending" },
    processing: { label: "In elaborazione", cls: "pxos-status-processing" },
    ready: { label: "Pronto", cls: "pxos-status-ready" },
    review_required: { label: "Richiede revisione", cls: "pxos-status-review" },
    confirmed: { label: "Confermato", cls: "pxos-status-confirmed" },
    rejected: { label: "Rifiutato", cls: "pxos-status-rejected" },
  };
  return map[s] || { label: s, cls: "pxos-status-pending" };
}
